/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCornerLeftUpDouble = createReactComponent(
  "corner-left-up-double",
  "IconCornerLeftUpDouble",
  [
    ["path", { d: "M18 19h-6a3 3 0 0 1 -3 -3v-7", key: "svg-0" }],
    ["path", { d: "M13 13l-4 -4l-4 4m8 -5l-4 -4l-4 4", key: "svg-1" }]
  ]
);

export { IconCornerLeftUpDouble as default };
//# sourceMappingURL=IconCornerLeftUpDouble.js.map
